module.exports = __webpack_public_path__ + "static/media/ground_breaking_photo.66637dc2.jpg";